module.exports = require("@swa-ui/core/src/Layout/Layout.module.scss");